module.exports = {
  getAPI: function () {
    return "https://livelms.in/api";
    // return "//206.189.139.71/~skillusr/beta/ws";
    // http://206.189.139.71/~skillusr/beta/ws
  },
  getSiteAPI: function () {
    return `https://${localStorage.getItem('lms_site_name')}.livelms.in/api`;
  },
  getLandingPageSiteAPI: function () {
    return `https://${window.location.hostname.split('.')[0]}.livelms.in/api`;
  },
  language_id: function () {
    return "1";
  },
  usermaster_id: function () {
    return "205";
  },
  user_type: function () {
    return "learner";
  },
  domain_code: function () {
    return "skillsacademy";
  },
  default_user_role_id: function () {
    return "3";
  },
  default_course_cat_list_type: function () {
    return "all";
  },
  uploadImage: (data) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    var imageArr = [data];
    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("media", imageArr);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };
    console.log(imageArr);

    fetch("https://livelms.in/api/media/add", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => console.log("error", error));
  },
  APIKey: function () {
    return "xuE9zmXUTBqEyX4eDrd91A";
  },
  APISecret: function () {
    return "Kxy6hAJkvFJg2cPhQXQQYocvTf99Eal5hlLi";
  },
  IMChatToken: function () {
    return "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzVHZNNEdKMlJaaVdncGV5MEYxZ3Z3In0.7_pd-fsabkk7AueDBnK2Uwi83INzYhG1yHTmch8C5O0";
  },
  APIURL: function () {
    return "http://api.zoom.us/v2/users/sTvM4GJ2RZiWgpey0F1gvw/meetings";
  },
  APIJWTToken: function () {
    return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOm51bGwsImlzcyI6Inh1RTl6bVhVVEJxRXlYNGVEcmQ5MUEiLCJleHAiOjE1OTAzMjAyMDYsImlhdCI6MTU5MDIzMzgwNn0.xwKMtB6T6tiqVN9N7w1DN8wRAGrIDAQr0Kj7HD-jn8Q";
  },
};
